(function () {
  'use strict';

  if (window.MaisonCart && window.MaisonCart.initialized) return;

  var drawer = document.querySelector('[data-maison-cart-drawer]');
  var overlay = document.querySelector('[data-maison-cart-overlay]');
  var previousFocus = null;
  var pageRequest = null;
  var suppressNextPageRefresh = false;
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function getDrawerStatus() {
    return drawer && drawer.querySelector('[data-maison-cart-drawer-status]');
  }

  function setStatus(element, message, state) {
    if (!element) return;
    element.textContent = message || '';
    if (state) element.dataset.state = state;
    else delete element.dataset.state;
  }

  function updateTriggerState(isOpen) {
    document.querySelectorAll('.js-call-minicart').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', String(isOpen));
    });
  }

  function openDrawer(source) {
    if (!drawer || !overlay) return;
    previousFocus = source instanceof HTMLElement ? source : document.activeElement;
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.dataset.open = 'true';
    drawer.classList.add('active');
    overlay.dataset.open = 'true';
    overlay.classList.add('active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('maison-cart-open');
    updateTriggerState(true);
    window.requestAnimationFrame(function () {
      var closeButton = drawer.querySelector('[data-maison-cart-close]');
      (closeButton || drawer).focus({ preventScroll: true });
    });
  }

  function closeDrawer(options) {
    if (!drawer || !overlay) return;
    var restoreFocus = !options || options.restoreFocus !== false;
    drawer.removeAttribute('data-open');
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    drawer.removeAttribute('aria-busy');
    overlay.removeAttribute('data-open');
    overlay.classList.remove('active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('maison-cart-open');
    updateTriggerState(false);
    setStatus(getDrawerStatus(), '');
    if (restoreFocus && previousFocus && previousFocus.isConnected) {
      previousFocus.focus({ preventScroll: true });
    }
    previousFocus = null;
  }

  function isDrawerOpen() {
    return Boolean(drawer && drawer.getAttribute('aria-hidden') === 'false');
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !isDrawerOpen()) return;
    var focusable = Array.prototype.filter.call(drawer.querySelectorAll(focusableSelector), function (element) {
      return element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
    });
    if (!focusable.length) {
      event.preventDefault();
      drawer.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function cartRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function cartErrorMessage(section, error) {
    if (error && error.message && error.message !== 'Failed to fetch') return error.message;
    return section && section.dataset.updateError ? section.dataset.updateError : window.maisonCartStrings.updateError;
  }

  function parseResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        throw new Error(data.description || data.message || window.maisonCartStrings.updateError || response.statusText);
      }
      return data;
    });
  }

  function refreshCartPage(section, statusMessage) {
    if (!section || !section.isConnected) return Promise.resolve(null);
    var sectionId = section.dataset.sectionId;
    var separator = window.location.search ? '&' : '?';
    var url = window.location.pathname + window.location.search + separator + 'section_id=' + encodeURIComponent(sectionId);
    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart section refresh failed.');
      return response.text();
    }).then(function (html) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      var replacement = wrapper.querySelector('[data-maison-cart-page]') || wrapper.firstElementChild;
      if (!replacement) throw new Error('Cart section response was incomplete.');
      section.replaceWith(replacement);
      setStatus(replacement.querySelector('[data-maison-cart-status]'), statusMessage || '', 'success');
      return replacement;
    });
  }

  function updatePageCart(section, payload) {
    if (!section || section.getAttribute('aria-busy') === 'true') return;
    if (pageRequest) pageRequest.abort();
    pageRequest = new AbortController();
    section.setAttribute('aria-busy', 'true');
    var status = section.querySelector('[data-maison-cart-status]');
    setStatus(status, window.maisonCartStrings.updating);

    fetch(cartRoot() + 'cart/' + payload.endpoint + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload.data),
      signal: pageRequest.signal
    }).then(parseResponse).then(function (cart) {
      return refreshCartPage(section, window.maisonCartStrings.updated).then(function (replacement) {
        suppressNextPageRefresh = true;
        if (window.ajaxCart && typeof window.ajaxCart.load === 'function') window.ajaxCart.load();
        document.dispatchEvent(new CustomEvent('maison:cart:page-updated', { detail: { cart: cart } }));
        return replacement;
      });
    }).catch(function (error) {
      if (error.name === 'AbortError') return;
      section.removeAttribute('aria-busy');
      setStatus(status, cartErrorMessage(section, error), 'error');
    }).finally(function () {
      pageRequest = null;
      if (section.isConnected) section.removeAttribute('aria-busy');
    });
  }

  function lineUpdateData(line, quantity) {
    return { endpoint: 'change', data: { line: line, quantity: quantity } };
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('.js-call-minicart');
    if (openTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openDrawer(openTrigger);
      return;
    }

    var closeTrigger = event.target.closest('[data-maison-cart-close], [data-maison-cart-overlay]');
    if (closeTrigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDrawer();
      return;
    }

    var section = event.target.closest('[data-maison-cart-page]');
    if (!section) return;
    var control = event.target.closest('[data-maison-cart-increase], [data-maison-cart-decrease], [data-maison-cart-remove]');
    if (!control) return;
    event.preventDefault();
    var line = Number(control.dataset.line);
    var input = section.querySelector('[data-maison-cart-quantity-input][data-line="' + line + '"]');
    var quantity = input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;
    if (control.hasAttribute('data-maison-cart-increase')) quantity += 1;
    if (control.hasAttribute('data-maison-cart-decrease')) quantity = Math.max(0, quantity - 1);
    if (control.hasAttribute('data-maison-cart-remove')) quantity = 0;
    updatePageCart(section, lineUpdateData(line, quantity));
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-maison-cart-quantity-input]');
    if (!input) return;
    var section = input.closest('[data-maison-cart-page]');
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    updatePageCart(section, lineUpdateData(Number(input.dataset.line), quantity));
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-maison-cart-form]');
    if (!form || !event.submitter || event.submitter.name !== 'update') return;
    event.preventDefault();
    var section = form.closest('[data-maison-cart-page]');
    var updates = Array.prototype.map.call(form.querySelectorAll('[data-maison-cart-quantity-input]'), function (input) {
      return Math.max(0, parseInt(input.value, 10) || 0);
    });
    updatePageCart(section, { endpoint: 'update', data: { updates: updates } });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isDrawerOpen()) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    trapFocus(event);
  });

  document.addEventListener('maison:cart:open', function (event) {
    openDrawer(event.detail && event.detail.source);
  });

  document.addEventListener('maison:cart:updating', function () {
    if (!drawer) return;
    drawer.setAttribute('aria-busy', 'true');
    setStatus(getDrawerStatus(), window.maisonCartStrings.updating);
  });

  document.addEventListener('maison:cart:updated', function () {
    if (drawer) drawer.removeAttribute('aria-busy');
    setStatus(getDrawerStatus(), window.maisonCartStrings.updated, 'success');
    var section = document.querySelector('[data-maison-cart-page]');
    if (!section) return;
    if (suppressNextPageRefresh) {
      suppressNextPageRefresh = false;
      return;
    }
    refreshCartPage(section, window.maisonCartStrings.updated).catch(function (error) {
      setStatus(section.querySelector('[data-maison-cart-status]'), cartErrorMessage(section, error), 'error');
    });
  });

  document.addEventListener('maison:cart:error', function (event) {
    if (drawer) drawer.removeAttribute('aria-busy');
    setStatus(getDrawerStatus(), event.detail && event.detail.message || window.maisonCartStrings.updateError, 'error');
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) closeDrawer({ restoreFocus: false });
  });

  updateTriggerState(false);
  window.maisonCartStrings = window.maisonCartStrings || {};
  window.MaisonCart = {
    initialized: true,
    open: openDrawer,
    close: closeDrawer
  };
}());
